import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PageTitle from "../common/text/PageTitle";
import * as actions from "./logSourceActions";
import {
  getFilters,
  getVisibleLogSourceGroups,
  getLogSourcesHasErrors
} from "./selectors";
import Filter from "../common/Filter";
import PageErrorMessage from "../common/PageErrorMessage";
import Spinner from "../common/progress/Spinner";
import translate from "react-i18next/dist/commonjs/translate";
import WidgetOverlayLinkToTa from "../dashboard/widgets/WidgetOverlayLinkToTa";
class LogSourcesPage extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.handleFilterClick = this.handleFilterClick.bind(this);
    this.handleSortByName = this.handleSortByName.bind(this);
    this.handleSortByType = this.handleSortByType.bind(this);
    this.handleSortByIpAddress = this.handleSortByIpAddress.bind(this);
    this.handleSortByStatus = this.handleSortByStatus.bind(this);
    this.onReload = this.onReload.bind(this);
  }

  componentDidMount() {
    this.props.actions.loadLogSources();
  }

  handleFilterClick(value) {
    this.props.actions.selectFilter(value);
  }

  handleSort(sortBy, sortFunc) {
    const logSourcesSorting = this.props.logSourcesSorting;
    const isSorted = logSourcesSorting.by === sortBy;

    let direction;
    if (isSorted) {
      direction = logSourcesSorting.direction === "desc" ? "asc" : "desc";
    } else {
      direction = "asc";
    }

    this.props.actions.sortLogSources({
      by: sortBy,
      func: sortFunc,
      direction
    });
  }

  handleSortByName() {
    this.handleSort("name", state => state.name.toLowerCase());
  }

  handleSortByType() {
    this.handleSort("groupName", state => state.groupName.toLowerCase());
  }

  handleSortByIpAddress() {
    this.handleSort("ip", state => parseInt(state.ip.replace(/\./g, "")));
  }

  handleSortByStatus() {
    this.handleSort("isOnline");
  }

  onReload() {
    this.props.actions.loadLogSources();
  }

    render() {
        const { t, customerInformation } = this.props;

        if (customerInformation.siem === "wazuh") {
            return (
                <div className="my-nodes-page">
                    <section className="main-content">
                        <PageTitle text={t("logSourcePageTitle")} />
                        <div className="container">
                            <div className="text-center">
                            <div className="linkDiv">
                                <a href={customerInformation.technicalAnalysisUrl} className="btn" target="_blank">
                                    {t("logInToTa")}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            )
        }
    if (this.props.isLoading) {
      return (
        <div className="my-nodes-page">
          <section className="main-content">
            <PageTitle text={t("logSourcePageTitle")} />
            <div className="container">
              <div className="text-center">
                <Spinner />
              </div>
            </div>
          </section>
        </div>
      );
    }

    if (this.props.hasErrors) {
      return (
        <div className="my-nodes-page">
          <section className="main-content">
            <PageTitle text={t("logSourcePageTitle")} />
            <div className="container">
              <div className="text-center">
                <PageErrorMessage onReload={this.onReload} />
              </div>
            </div>
          </section>
        </div>
      );
    }

    return (
      <div className="my-nodes-page">
        <section className="main-content">
          <PageTitle text={t("logSourcePageTitle")} />
          <div className="container">
            <i className="fa fa-filter" /> Type:{" "}
            {this.props.filters.map((f, i) => (
              <Filter
                key={i}
                value={f.key}
                handleClick={this.handleFilterClick}
                isSelected={f.isSelected}
              />
            ))}
            <table className="table table-responsive table-hover table-sortable table-ui">
              <thead>
                <tr>
                  <th />
                  <th onClick={this.handleSortByName}>
                    {t("LogSourcesPageTableThName")}
                    <i className="fa fa-sort pull-right text-muted" />
                  </th>
                  <th onClick={this.handleSortByType}>
                    {t("LogSourcesPageTableThType")}
                    <i className="fa fa-sort pull-right text-muted" />
                  </th>
                  <th onClick={this.handleSortByIpAddress}>
                    {t("LogSourcesPageTableThIP")}
                    <i className="fa fa-sort pull-right text-muted" />
                  </th>
                  <th onClick={this.handleSortByStatus}>
                    {t("LogSourcesPageTableThStatus")}
                    <i className="fa fa-sort pull-right text-muted" />
                  </th>
                </tr>
              </thead>
              <tbody>
                {this.props.visibleLogSources.map(logSource => {
                  return (
                    <tr key={logSource.name}>
                      <td />
                      <td style={{ fontWeight: "500" }}>{logSource.name}</td>
                      <td>{logSource.groupName}</td>
                      <td>{logSource.ip}</td>
                      <td>
                        <i
                          className={
                            logSource.isOnline
                              ? "fa fa-1 fa-check text-success"
                              : "fa fa-1 fa-close text-critical"
                          }
                        />
                        {logSource.isOnline ? " Online" : " Offline"}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </section>
      </div>
    );
  }
}

LogSourcesPage.propTypes = {
  logSources: PropTypes.array.isRequired,
  filters: PropTypes.array.isRequired,
  actions: PropTypes.object.isRequired,
  visibleLogSources: PropTypes.array.isRequired,
  logSourcesSorting: PropTypes.object.isRequired,
  isLoading: PropTypes.bool.isRequired,
  hasErrors: PropTypes.bool.isRequired,
  customerInformation: PropTypes.object.isRequired,
};

function mapStateToProps(state, ownProps) {
  return {
    logSources: state.logSources,
    filters: getFilters(state),
    visibleLogSources: getVisibleLogSourceGroups(state),
    logSourcesSorting: state.logSourcesSorting,
    isLoading: state.logSourcesIsLoading,
    hasErrors: getLogSourcesHasErrors(state),
    customerInformation: state.customerInformation
  };
}

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(actions, dispatch)
  };
};

export default translate("translations")(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(LogSourcesPage)
);



// WEBPACK FOOTER //
// ./src/log-sources/LogSourcesPage.js